import { FetchQueryOptions } from '@tanstack/react-query';

import { api } from '@api';

export const FETCH_APARTMENTS_QUERY_KEY = ['fetch-apartments'];

export const fetchApartmentsQuery = {
  queryKey: FETCH_APARTMENTS_QUERY_KEY,
  queryFn: async () => {
    const { status, data } = await api.apartments.getApartments();

    if (status !== 200 || !data?.ownApartments) {
      throw Error('Error fetching apartments');
    }

    return data.ownApartments;
  },
} satisfies FetchQueryOptions;
